module.exports = __webpack_public_path__ + "static/fonts/iconfont.d6a08dff.woff";